export const ThreeDotsSvg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16.1 16.1"
    {...props}
  >
    <circle cx="2" cy="6" r="2" />
    <circle cx="8" cy="6" r="2" />
    <circle cx="14" cy="6" r="2" />
  </svg>
);
